module.exports = __webpack_public_path__ + "static/media/close_mobile.fbfa8e26.png";